import { Box, Button, Grid2, Typography } from '@mui/material';
import { MuiOtpInput } from 'mui-one-time-password-input';
import React, { useEffect, useState } from 'react';
import CommonButtonActionButton from '../common/CommonButtonActionButton';

const OTPVerification = ({ formData, setFormData, handleNext, handleBack }) => {
    const [timer, setTimer] = useState(60); // Starting timer at 60 seconds
    const [isResendDisabled, setIsResendDisabled] = useState(true);

    useEffect(() => {
        // Timer logic to count down
        if (timer === 0) {
            setIsResendDisabled(false); // Enable resend OTP button when timer reaches 0
            return; // Stop the countdown
        }

        const intervalId = setInterval(() => {
            setTimer((prevTimer) => prevTimer - 1); // Decrease timer by 1 each second
        }, 1000);

        // Cleanup function to clear the interval when the component unmounts or timer reaches 0
        return () => clearInterval(intervalId);
    }, [timer]);

    const handleResendOTP = () => {
        setTimer(60); // Reset timer on resend
        setIsResendDisabled(true); // Disable resend button immediately after OTP is sent
        // Logic to resend OTP here
    };
    const formatTimer = () => {
        const minutes = Math.floor(timer / 60);
        const seconds = timer % 60;
        return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`; // Add leading zero for seconds if < 10
    };
    return (
        <Grid2 container>
            <Grid2 size={{ lg: 6 }}>
                <Box display={'flex'} sx={{ marginTop: "117px" }} alignItems={'center'} textAlign={'center'}>
                    <img src="/assets/images/background/payment-two-step.svg"></img>
                </Box>
                {/* You can add an image here */}

            </Grid2>
            <Grid2 size={{ lg: 6 }} sx={{
                borderRadius: "0px 10px 10px 0px",
                background: "#F7F7F7",
                padding: "30px"
            }}>
                <Box display={'flex'} flexDirection={'column'} rowGap={2} sx={{ margin: "20px 12%" }} alignItems={'center'} textAlign={'center'}>
                    <Typography className="header-label" gutterBottom>
                        OTP Verification
                    </Typography>
                    <Typography>To ensure your security, please enter the One-Time Password (OTP) sent to your registered mobile number/email below.</Typography>

                    <MuiOtpInput
                        fullWidth
                        value={formData.otp}
                        onChange={(e) => setFormData({ ...formData, otp: e.target.value })}
                    />
                    <Typography color='error' fontSize={'16px'}>{isResendDisabled ? formatTimer() : ''}</Typography>
                    <p>
                        Didn't receive the OTP?
                        <Button
                            disabled={isResendDisabled}
                            onClick={handleResendOTP}
                            sx={{ textTransform: 'none' }}
                        >
                            Resend
                        </Button>
                    </p>

                    <Box sx={{ mt: 4 }} display={'flex'} flexDirection={'column'} rowGap={4} width={'100%'}>

                        <CommonButtonActionButton fullWidth onClick={handleNext} sx={{ padding: "10px" }} >
                            Verify
                        </CommonButtonActionButton>
                        <CommonButtonActionButton buttonVarient="outlined" variant={'secondary'} onClick={handleBack} fullWidth sx={{ padding: "10px" }}>
                            Cancel
                        </CommonButtonActionButton>
                    </Box>
                    <p>
                        Having difficulties with OTP?
                        <Button

                        >
                            Get help

                        </Button>
                    </p>

                </Box>


            </Grid2>
        </Grid2>
    );
};

export default OTPVerification;
